import { render, staticRenderFns } from "./item6.vue?vue&type=template&id=3d16a528&scoped=true"
import script from "./item6.vue?vue&type=script&lang=js"
export * from "./item6.vue?vue&type=script&lang=js"
import style0 from "./item6.vue?vue&type=style&index=0&id=3d16a528&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d16a528",
  null
  
)

export default component.exports